import React, { Component } from "react";
import Img from "react-image";
import { connect } from "react-redux";
import { getEvent } from "../evenements/Evenements.ducks";
import {
  getAllEvent,
  DeleteEvent,
  cancelEvent,
} from "../evenements/Evenements.ducks";
import fr_moment from "../../../../utils/momentjs-config/fr_moment";

import ModaleParticipants from "./ModaleParticipants";
import ModalDelete from "./ModalDelete";
import ModalWarning from "./ModalWarning";
import ModaleNewEvent from "./ModaleNewEvent";
import ModaleEditEvent from "./ModaleEditEvent";
import ModaleConfirmationDelete from "./ModaleConfirmationDelete";
import srcIconParticipants from "../../../../styles/img/icon-participants.svg";
import srcIconAddWhite from "../../../../styles/img/add-white.svg";
import moment from "moment";
import Classnames from "classnames";
import { getMonth } from "date-fns";
import _ from "lodash";
import DotLoader from "react-spinners/DotLoader";
import { css } from "@emotion/core";
import axios from "axios";
import { API } from "../../../../const";
import { Service } from "../../../../modules/service/service";
import InfiniteScroll from "react-infinite-scroll-component";
import Intercom from "react-intercom";
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';

moment.locale("fr");

const IconParticipants = () => (
  <Img src={srcIconParticipants} className="modalP img-fluid" />
);
const IconAddWhite = () => <Img src={srcIconAddWhite} className="img-fluid" />;
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Evenements extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ModaleParticipants: false,
      modalDelete: false,
      modalWarning: false,
      ModaleNewEvent: false,
      ModalEditEvent: false,
      hasMoreItems: true,
      page: [],
      ModaleConfirmationDelete: false,
      eventId: "",
      listEvents: [],
      eventsLoading: true,
      scrollLoader: false,
      offset: 1,
      event: {},
      componentStyle: false,
    };
    this.showModaleParticipants = this.showModaleParticipants.bind(this);
    this.onCloseModaleParticipants = this.onCloseModaleParticipants.bind(this);
    this.openModalDelete = this.openModalDelete.bind(this);
    this.closeModalDelete = this.closeModalDelete.bind(this);
    this.openModalWarning = this.openModalWarning.bind(this);
    this.closeModalWarning = this.closeModalWarning.bind(this);
    this.showModaleNewEvent = this.showModaleNewEvent.bind(this);
    this.onCloseModaleNewEvent = this.onCloseModaleNewEvent.bind(this);
    this.showModaleEditEvent = this.showModaleEditEvent.bind(this);
    this.CloseModalEdit = this.CloseModalEdit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.windowClick = this.windowClick.bind(this);
    this.showModaleConfirmationDelete = this.showModaleConfirmationDelete.bind(
      this
    );
    this.onCloseModaleConfirmationDelete = this.onCloseModaleConfirmationDelete.bind(
      this
    );
    this.handleDeleteEvent = this.handleDeleteEvent.bind(this);
    this.handleCancelEvent = this.handleCancelEvent.bind(this);
    this.loadMore = this.loadMore.bind(this);
    this.handleClickId = this.handleClickId.bind(this);
  }

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleClickId = (eventId) => {
    let event = this.state.listEvents.find((element) => element.id === eventId);
    this.setState({ event: event, eventId: eventId });
  };

  showModaleEditEvent = () => {
    this.setState({
      ModaleEditEvent: true,
      componentStyle: true,
    });
  };
  CloseModalEdit = () => {
    this.setState({
      ModaleEditEvent: false,
      ModaleNewEvent: false,
      componentStyle: false,
    });
  };

  showModaleParticipants(element) {
    this.setState({ ModaleParticipants: true });
  }
  onCloseModaleParticipants() {
    this.setState({ ModaleParticipants: false });
  }

  openModalDelete(element) {
    this.setState({ modalDelete: true });
  }
  closeModalDelete() {
    this.setState({ modalDelete: false });
  }

  openModalWarning(element) {
    this.setState({ modalWarning: true });
  }
  closeModalWarning() {
    this.setState({ modalWarning: false });
  }

  showModaleNewEvent() {
    this.setState({ ModaleNewEvent: true, componentStyle: true });
  }
  onCloseModaleNewEvent() {
    this.setState({ ModaleNewEvent: false, componentStyle: false });
  }
  showModaleConfirmationDelete(offset) {
    this.setState({ ModaleConfirmationDelete: true });
  }
  onCloseModaleConfirmationDelete() {
    this.setState({ ModaleConfirmationDelete: false });
  }
  componentDidMount() {
    let tok = localStorage.getItem("token");
    if (window) {
      window.addEventListener("click", this.windowClick, false);
    }
    const response = Service.get(
      `${API}api/creche/events?offset=1&path-size=20`,
      { headers: { Authorization: `Bearer ${tok}` } }
    );
    response.then((res) => {
      let sortedEvents = res.data.events.elements.sort((a, b) =>
        moment(b.dateTime).diff(a.dateTime)
      );
      this.setState({
        listEvents: sortedEvents,
        eventsLoading: false,
        page: res.data.events.pagesNumber,
        totalElements: res.data.events.totalElements,
      });
    });
  }
  componentDidUpdate(prevProps) {
    if (
      prevProps.dataEvents !== this.props.dataEvents &&
      !_.isEmpty(this.props.dataEvents.events)
    ) {
      this.setState({
        listEvents: this.props.dataEvents.events.elements,
        hasMoreItems: true,
        eventsLoading: false,
        scrollLoader: false,
        offset: 1,
      });
    }
  }
  loadMore() {
    this.setState({
      scrollLoader: true,
    });
    if (this.state.listEvents.length === this.state.totalElements) {
      this.setState({ hasMoreItems: false });
    } else {
      setTimeout(() => {
        let tok = localStorage.getItem("token");
        let offset = this.state.offset + 1;

        const response = Service.get(
          `${API}api/creche/events?offset=${offset}&path-size=20`,
          { headers: { Authorization: `Bearer ${tok}` } }
        );
        response.then((res) => {
          let sortedEvents = this.state.listEvents.concat(
            res.data.events.elements
          );
          sortedEvents = sortedEvents.sort((a, b) =>
            moment(b.dateTime).diff(a.dateTime)
          );
          this.setState({
            listEvents: sortedEvents,
            offset: offset,
            scrollLoader: false,
          });
        });
      }, 500);
    }
  }
  handleDeleteEvent = (e) => {
    e.preventDefault();
    this.props.DeleteEvent(
      localStorage.getItem("token"),
      this.state.eventId,
      this.state.offset
    );
    this.setState({
      ModaleConfirmationDelete: false,
      ModaleEditEvent: false,
      modalDelete: false,
    });
  };
  handleCancelEvent = (e) => {
    e.preventDefault();
    this.props.cancelEvent(
      localStorage.getItem("token"),
      this.state.eventId,
      this.state.offset
    );
    this.setState({
      ModaleConfirmationDelete: false,
      ModaleEditEvent: false,
      modalDelete: false,
    });
  };
  componentWillUnmount() {
    window.removeEventListener("click", this.windowClick, false);
  }
  windowClick(event) {
    if (event.target.classList.contains("modalP")) {
      this.setState({
        ModaleParticipants: true,
      });
    } else if (event.target.classList.contains("modalEdit")) {
      if (
        this.state.event.statutEvent === "ANNULE" ||
        moment(this.state.event.dateTime).isBefore()
      ) {
        this.setState({
          modalWarning: true,
        });
      } else {
        this.setState({
          ModaleEditEvent: true,
        });
      }
    }
  }
  render() {
    const { t } = this.props;
    const { email, id, nom } = this.props.dataCompte;
    const user = JSON.stringify({
      user_id: id,
      email: email,
      name: nom,
    });

    var items = [];
    const divStyle = {
      overflow: "none",
    };
    if (!_.isEmpty(this.state.listEvents)) {
      this.state.listEvents.map((element, i) => {
        items.push(
          <div
            className="col-md-6 pl-0 modalEdit"
            onClick={(e) => this.handleClickId(element.id)}
            key={i}
          >
            <div
              onClick={(e) => this.handleClickId(element.id)}
              key={i}
              className={Classnames(
                "bloc-event bloc-event-detail modalEdit   mt-4 box-shadow d-flex align-items-stretch",
                {
                  "past-event":
                    moment(element.dateTime).isBefore() ||
                    element.statutEvent === "ANNULE",
                }
              )}
            >
              <button
                onClick={this.openModalDelete}
                className="delete-event"
                data-toggle="modal"
              ></button>
              <div className="date-event d-flex align-items-center gradient modalEdit">
                <div className="content modalEdit">
                  <span className="modalEdit">
                    {moment(element.dateTime).format("DD")}
                  </span>
                  <p className="modalEdit">
                    {moment(element.dateTime).format("MMM")}
                  </p>
                </div>
              </div>
              <div className="desc-event modalEdit">
                <h3 className="modalEdit">{element.titre}</h3>
                {element.statutEvent === "PLANIFIE" ||
                _.isEmpty(element.statutEvent) ? (
                  <p className="modalEdit">
                    {moment(element.dateTime).format("HH[h]mm")}{" "}
                  </p>
                ) : element.statutEvent === "DATE_MODIFEE" ? (
                  <p className="modalEdit">
                    {moment(element.dateTime).format("HH[h]mm") + " "}
                    <div style={{ textDecoration: "line-through" }}>
                      {!_.isEmpty(element.lastDateTime) &&
                        moment(element.lastDateTime).format("DD MMMM HH[h]mm")}
                    </div>
                  </p>
                ) : (
                  <p className="modalEdit">{t('events.cancelled')}</p>
                )}
                {element.parentsInivites === true ? (
                  <a
                    className="btn-white modalP"
                    data-toggle="modal"
                    data-target="#modalParticipants"
                  >
                    <IconParticipants />
                    {this.props.t('events.participants')}
                  </a>
                ) : (
                  <a
                    className="btn-white btn-no-bg"
                    data-toggle="modal"
                    data-target="#modalParticipants"
                  >
                    {" "}
                    {t('events.no_participants')}
                  </a>
                )}
              </div>
            </div>
          </div>
        );
      });
    }
    items = <div className="row">{items}</div>;
    return (
      <>
        <div className="main-wrapper fiche-enfant gestion-creche">
          <div className="banner p-0 d-flex align-items-center justify-content-center">
            <Link to="/" className="back-link">
              Retour
            </Link>
            <div className="content">
              <h1>
                Événements
                <br />
                <small>{t('events.subtitle')}</small>
              </h1>
            </div>
            <a
              onClick={this.showModaleNewEvent}
              href="#"
              className="btn-event btn-gradient shadow-none"
              data-toggle="modal"
              data-target="#modalNewEvent"
            >
              <IconAddWhite /> <span>Créer un événement</span>
            </a>
          </div>
          <div className="container pt-4">
            <InfiniteScroll
              style={divStyle}
              dataLength={this.state.listEvents.length}
              next={this.loadMore}
              hasMore={this.state.hasMoreItems}
              loader={
                <div className="content p-0">
                  <DotLoader
                    size={100}
                    color={"#ff7d26"}
                    css={override}
                    loading={this.state.eventsLoading}
                  />
                </div>
              }
            >
              {items}
            </InfiniteScroll>
          </div>
          {this.state.ModaleEditEvent === true ? (
            <ModaleEditEvent
              CloseModalEdit={this.CloseModalEdit}
              event={this.state.event}
              showModaleConfirmationDelete={this.showModaleConfirmationDelete}
              onCloseModaleConfirmationDelete={
                this.onCloseModaleConfirmationDelete
              }
              ModaleConfirmationDelete={this.state.ModaleConfirmationDelete}
              handleDeleteEvent={this.handleDeleteEvent}
              eventId={this.state.eventId}
              offset={this.props.offset}
              values={this.state}
            />
          ) : (
            ""
          )}
          {this.state.ModaleConfirmationDelete ? (
            <ModaleConfirmationDelete
              onCloseModaleConfirmationDelete={
                this.onCloseModaleConfirmationDelete
              }
              handleDeleteEvent={this.handleDeleteEvent}
              eventId={this.state.eventId}
              dataEvents={this.props.dataEvents}
              values={this.state}
            />
          ) : (
            ""
          )}
          {this.state.ModaleParticipants ? (
            <ModaleParticipants
              onCloseModaleParticipants={this.onCloseModaleParticipants}
              event={this.state.event}
              values={this.state}
            />
          ) : (
            ""
          )}
          {this.state.modalDelete ? (
            <ModalDelete
              onClose={this.closeModalDelete}
              handleDeleteEvent={this.handleDeleteEvent}
              handleCancelEvent={this.handleCancelEvent}
              event={this.state.event}
            />
          ) : (
            ""
          )}
          {this.state.modalWarning ? (
            <ModalWarning
              onClose={this.closeModalWarning}
              event={this.state.event}
            />
          ) : (
            ""
          )}
          {this.state.ModaleNewEvent === true ? (
            <ModaleNewEvent
              CloseModalEdit={this.CloseModalEdit}
              values={this.state}
              handleChange={this.handleChange}
            />
          ) : (
            ""
          )}
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => ({
  dataEvents: state.Evenements.data,
  dataEventById: state.Evenements.dataEventById,
  eventsLoading: state.Evenements.loading,
  dataCompte: state.compte.data,
});

export default connect(mapStateToProps, {
getEvent,
  getAllEvent,
  DeleteEvent,
  cancelEvent,
})(withTranslation()(Evenements));
